import { useInvalidate, useList } from '@refinedev/core';

export type DataUploadModel = {
  id: string;
  displayName: string;
  description: string;
  parserType: string;
  displayOrder: number;
  shortName: string;
};

export default function useDataUploadModels() {
  const resource = 'data-upload-models';

  const { data, isFetching, isError } = useList<DataUploadModel>({
    resource,
    queryOptions: {
      select: data => ({
        ...data,
        data: data.data.map(file => ({
          ...file,
          description: file.description?.replace(/\\n/g, '\n'),
        })),
      }),
    },
  });

  const invalidate = useInvalidate();

  return {
    files: data?.data ?? [],
    isLoading: isFetching,
    isError,
    refetch: () =>
      invalidate({
        resource,
        invalidates: ['list'],
      }),
  };
}
